import moment from 'moment';

export default class CandidateAssessment {
  id: string;

  link: string;

  linkDescription: string;

  cultureGrade: number | string;

  cultureGradePercentage: number | null;

  candidateId: string;

  candidateName: string;

  candidateEmail: string;

  numericalReasoningGrade: number | null;

  numericalReasoningGradePercentage: number | null;

  verbalReasoningGrade: number | null;

  verbalReasoningGradePercentage: number | null;

  startDate: string;

  closedDate: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.link = obj.link || '';
    this.linkDescription = obj.linkDescription || '';
    this.cultureGrade = obj.cultureGrade;
    this.cultureGradePercentage = obj.cultureGradePercentage;
    this.candidateId = obj.candidateId || '';
    this.candidateName = obj.candidateName || '';
    this.candidateEmail = obj.candidateEmail || '';
    this.numericalReasoningGrade = obj.numericalReasoningGrade;
    this.verbalReasoningGrade = obj.verbalReasoningGrade;
    this.numericalReasoningGradePercentage = obj.numericalReasoningGradePercentage;
    this.verbalReasoningGradePercentage = obj.verbalReasoningGradePercentage;
    this.startDate = obj.startDate || '';
    this.closedDate = obj.closedDate || '';
  }

  get startDateFormated() {
    return this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
  }

  get closedDateFormated() {
    return this.closedDate ? moment(this.closedDate).format('DD/MM/YYYY') : '';
  }
}
